export default {
  name: 'MainNavMenu',
  data () {
    return {
      navSections: [
        {
          menuName: 'Clinic',
          permissionKey: 'm:clinic',
          class: 'nav-section',
          routes: [
            {
              routeName: 'ClinicDashboard',
              menuName: 'Clinic Dashboard',
              class: 'nav-item',
              exact: true
            },
            {
              routeName: 'ClinicPatients',
              menuName: 'Patient Roster',
              class: 'nav-item'
            },
            {
              routeName: 'ClinicTherapists',
              menuName: 'Therapist Roster',
              class: 'nav-item'
            },
            {
              routeName: 'ClinicNotificationManager',
              menuName: 'Notification Manager',
              class: 'nav-item'
            },
            {
              routeName: 'QuickStart',
              menuName: 'OVB Quick Start',
              class: 'nav-item'
            },
            // {
            //   routeName: 'OldUsers',
            //   menuName: 'Old Users',
            //   class: 'nav-item',
            //   permissionFn: this.showOldUsers
            // },
            {
              routeName: 'ClinicSessionManager',
              menuName: 'Activity Sessions',
              class: 'nav-item'
            },
            {
              routeName: 'ActivityAssignmentReview',
              menuName: 'Assignment Review',
              class: 'nav-item'
            },
            {
              routeName: 'HelpCenter',
              menuName: 'Help Center',
              class: 'nav-item'
            }
          ]
        },
        {
          menuName: 'Patient',
          permissionKey: 'm:patient',
          class: 'nav-section',
          routes: [
            {
              routeName: 'PatientDashboard',
              menuName: 'Patient Dashboard',
              class: 'nav-item'
            }
          ]
        },
        {
          menuName: 'OVB Silver',
          permissionKey: 'm:silver',
          class: 'nav-section',
          routes: [
            {
              routeName: 'GameRoomSilver',
              menuName: 'Game Room',
              class: 'nav-item'
            },
            {
              routeName: 'GamesExplorer',
              menuName: 'Games Explorer',
              class: 'nav-item'
            }
          ]
        },
        {
          menuName: 'Clinic Trial',
          permissionKey: 'm:clinic-trial',
          class: 'nav-section',
          routes: [
            {
              routeName: 'ClinicTrial',
              menuName: 'Trial Dashboard',
              class: 'nav-item'
            },
            {
              routeName: 'ClinicPricing',
              menuName: 'Pricing',
              class: 'nav-item'
            },
            {
              routeName: 'PurchaseUpgrade',
              menuName: 'Purchase Upgrade',
              class: 'nav-item'
            },
            {
              routeName: 'GamesExplorer',
              menuName: 'Games Explorer',
              class: 'nav-item'
            }
          ]
        },
        {
          menuName: 'OVB Administration',
          permissionKey: this.showSuperAdmin,
          class: 'nav-section',
          routes: [
            {
              routeName: 'OvbDashboard',
              menuName: 'OVB Dashboard',
              class: 'nav-item'
            },
            {
              routeName: 'SupportCenter',
              menuName: 'Support Center',
              class: 'nav-item'
            },
            {
              routeName: 'DemoCenter',
              menuName: 'Demo Center',
              class: 'nav-item'
            },
            {
              routeName: 'NotificationManager',
              menuName: 'Notification Manager',
              class: 'nav-item'
            },
            {
              routeName: 'HelpCenterAdmin',
              menuName: 'Help Center',
              class: 'nav-item'
            },
            // {
            //   routeName: 'MessagingManager',
            //   menuName: 'Messaging'
            // },
            // {
            //   routeName: 'HelpTopicManager',
            //   menuName: 'Help Manager'
            // },
            {
              routeName: 'ActivitySessionExplorer',
              menuName: 'Activity Sessions',
              class: 'nav-item'
            },
            {
              routeName: 'ActivityErrors',
              menuName: 'Activity Errors',
              class: 'nav-item'
            },
            {
              routeName: 'OldCustomers',
              menuName: 'Old Customers',
              class: 'nav-item'
            }
          ]
        },
        {
          menuName: 'OVB Content',
          permissionKey: ['p:super-admin', 'p:ovb-activity-developer'],
          class: 'nav-section',
          routes: [
            {
              routeName: 'ActivityManager',
              menuName: 'Activity Manager',
              permissionKey: 'p:ovb-activity-developer',
              class: 'nav-item'
            },
            {
              routeName: 'WeMoveManager',
              menuName: 'Video Manager',
              permissionKey: 'p:super-admin',
              class: 'nav-item'
            },
            {
              routeName: 'WorksheetManager',
              menuName: 'Worksheet Manager',
              permissionKey: 'p:super-admin',
              class: 'nav-item'
            },
            {
              routeName: 'ActivityCategorizationManager',
              menuName: 'Categorizations',
              permissionKey: 'p:super-admin',
              class: 'nav-item'
            },
            {
              routeName: 'ActivityConfigurationLibrary',
              menuName: 'Configuration Library',
              permissionKey: 'p:super-admin',
              class: 'nav-item'
            },
            {
              routeName: 'ActivityLanguageManager',
              menuName: 'Activity Language Manager',
              permissionKey: 'p:super-admin',
              class: 'nav-item'
            }
          ]
        },
        {
          menuName: 'Activities',
          permissionKey: ['m:activities', 'p:super-admin'],
          class: 'nav-section explorer-themed',
          routes: [
            {
              routeName: 'ActivityExplorer',
              menuName: 'Activity Explorer',
              class: 'nav-item explorer-themed'
            },
            {
              routeName: 'WorksheetExplorer',
              menuName: 'Worksheet Explorer',
              class: 'nav-item explorer-themed'
            },
            {
              routeName: 'WeMoveExplorer',
              menuName: 'Video Explorer',
              class: 'nav-item explorer-themed'
            },
            // {
            //   routeName: 'ActivityDemos',
            //   menuName: 'Activity Demos'
            // },
            {
              routeName: 'ClinicGamePlayLists',
              menuName: 'PlayList Library',
              class: 'nav-item'
            }
          ]
        },
        {
          menuName: 'OVB Partner',
          permissionKey: ['p:app-demo-admin', 'p:app-tenant-group-admin'],
          class: 'nav-section',
          routes: [
            {
              routeName: 'DemoCenter',
              menuName: 'Demo Center',
              permissionKey: 'p:app-demo-admin',
              class: 'nav-item'
            },
            {
              routeName: 'SupportCenter',
              menuName: 'Support Center',
              permissionKey: 'p:app-tenant-group-admin',
              class: 'nav-item'
            }
          ]
        },
        {
          menuName: 'Clinic Administration',
          permissionKey: 'm:clinic-admin',
          class: 'nav-section',
          routes: [
            {
              routeName: 'MySubscription',
              menuName: 'Subscriptions',
              class: 'nav-item'
            },
            {
              routeName: 'AppTenantAppUsers',
              menuName: 'Users',
              class: 'nav-item'
            },
            {
              routeName: 'Billing',
              menuName: 'Billing',
              permissionKey: this.showAdminNoSuperAdmin,
              class: 'nav-item'
            },
            {
              routeName: 'ActivityLanguageManager',
              menuName: 'Activity Language Manager',
              permissionKey: 'p:manage-game-language',
              class: 'nav-item'
            }
            // {
            //   routeName: 'AppTenantSettings',
            //   menuName: 'Settings'
            // }
          ]
        },
        {
          menuName: 'Site Administration',
          permissionKey: this.showSuperAdmin,
          class: 'nav-section',
          routes: [
            {
              routeName: 'LicensePackManager',
              menuName: 'License Packs',
              class: 'nav-item'
            },
            {
              routeName: 'AppTenantManager',
              menuName: 'App Tenants',
              class: 'nav-item'
            },
            {
              routeName: 'GuestUsers',
              menuName: 'Guest Users',
              class: 'nav-item'
            },
            {
              routeName: 'ProjectManager',
              menuName: 'Workflow',
              class: 'nav-item'
            },
            // {
            //   routeName: 'ImageManager',
            //   menuName: 'Images'
            // },
            {
              routeName: 'ApplicationManager',
              menuName: 'Application',
              class: 'nav-item'
            },
            {
              routeName: 'ManagerManager',
              menuName: 'Manager Manager',
              class: 'nav-item'
            },
            {
              routeName: 'EulaManager',
              menuName: 'Saas Agreement Manager',
              class: 'nav-item'
            }
          ]
        },
        {
          menuName: 'Anchor Tenant',
          permissionKey: this.showSuperAdmin,
          class: 'nav-section',
          routes: [
            {
              routeName: 'MySubscription',
              menuName: 'Subscriptions',
              class: 'nav-item'
            },
            {
              routeName: 'AppTenantAppUsers',
              menuName: 'Users',
              class: 'nav-item'
            }
          ]
        }
      ]
    }
  },
  methods: {
    hasPermission (permissionKey) {
      return typeof (permissionKey) === 'function' ? permissionKey() : this.$userHasPermission(permissionKey)
    },
    showSuperAdmin () {
      return !this.$store.state.user.actualAppUserInfo && this.$userHasPermission('p:super-admin')
    },
    showAdminNoSuperAdmin () {
      return this.$userHasPermission('m:admin') && !this.$userHasPermission('p:super-admin')
    },
    showOldUsers () {
      return this.$store.state.user.showOldUsers
    },
    filteredRoutes (routes) {
      return routes.filter(r => {
        if (r.permissionKey) {
          return this.hasPermission(r.permissionKey)
        }
        if (r.permissionFn) {
          return r.permissionFn()
        }
        return true
      })
    }
  }
}
